import React, { useState, useEffect } from "react";
import Icon from "./Icons";

const CustomerItem = ({
  title,
  subTitle,
  onchange,
  defaultValue,
  max,
  min,
}) => {
  const [count, setCount] = useState(defaultValue ? parseInt(defaultValue) : 0);
  const [isFirst, setIsFirst] = useState(0);

  function countUp() {
    if (max || max == 0) {
      if (count < max) setCount(count + 1);
    } else {
      setCount(count + 1);
    }
  }
  function countDown() {
    if (min) {
      if (count > min) setCount(count - 1);
    } else {
      if (count > 0) setCount(count - 1);
    }
  }

  useEffect(() => {
    if (isFirst == 1) onchange(count);
    setIsFirst(1);
  }, [count]);

  return (
    <div className="flex justify-between items-center mb-2.5">
      <div className="flex flex-col">
        <span className="font-bold text-sm">{title}</span>
        {subTitle && (
          <span className="font-medium opacity-30 text-xs">{subTitle}</span>
        )}
      </div>
      <div className="flex">
        <button
          type="button"
          className="w-8 h-8 border border-brand-gray-8 flex items-center justify-center"
          onClick={countDown}
        >
          <Icon name={"Minus"}></Icon>
        </button>
        <span className="w-10 h-8 text-center leading-7 font-bold text-xl text-brand-black-2">
          {count}
        </span>
        <button
          type="button"
          className="w-8 h-8 border border-brand-gray-8 flex items-center justify-center"
          onClick={countUp}
        >
          <Icon name={"Plus"}></Icon>
        </button>
      </div>
    </div>
  );
};

export default CustomerItem;
